/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState } from 'react'
import { PropertyHandlers } from '../state/actions';
import Dragger from 'antd/lib/upload/Dragger';
import { Button, Modal, message, Checkbox } from 'antd';
import { InboxOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from 'react-redux';
import { changeExtensiontoLowerCase, getCoAgentsIds, getPreSignedUrls, uploadFileToS3 } from '../../Common/utils/extraFunctions';
import { customerDocsContTractTypes } from '../../Common/commondata/commonData';
import { Loading } from '../../Common/components/Loading';
import { useEffect } from 'react';
import { transactionLaneDataHandle } from '../../Rtd/state/actions';

export default function UploadPdfDoc({ selectedData, allData, setAllData, handleModalCancel, open, successFuncAll, getCoordinateItem, source, }) {
    const dispatch = useDispatch();
    const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const { getUserDetailsData } = useSelector((state) => state.account);

  const initialSignatureOfRef = useRef([]);
  const initialFileNameRef = useRef(null);
  const [selectedChecklists, setSelectedChecklists] = useState([]);

    const checkboxOptions = [
        { label: "Buyer", value: "BUYER" },
        { label: "Buyer Agent", value: "BUYER_AGENT" },
        { label: "Seller", value: "SELLER" },
        { label: "Seller Agent", value: "SELLER_AGENT" },
      ];

      const handleCheckboxChange = (checkedValues) => {
        setSelectedChecklists(checkedValues);
      };

    function beforeUpload(file) {
        let supportedFormats = file?.type;
        if (supportedFormats?.includes("pdf")) {
          const isPdf = file.type === "application/pdf";
          if (!isPdf) {
            message.error("You can only upload PDF file!");
          }
          const isLt2M = file.size / 1024 / 1024 < 100;
          if (!isLt2M) {
            message.error("File must be smaller than 100MB!");
          }
          return isPdf && isLt2M;
        }
    }
    
    function bytesToSize(bytes) {
        let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
        if (bytes === 0) return "0 Byte";
        let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    }
    
    let handleCustome = (data) => {
      const fileName = changeExtensiontoLowerCase(data?.file?.name);
      const updatedFile = new File([data.file], fileName, {
        type: data.file.type,
        lastModified: data.file.lastModified,
      });
      setSelectedFile(updatedFile);
    };
    
    const successFunc = () => {
        if(successFuncAll){
            successFuncAll();
        }
    }
  const handleSave = async () => {
    if (allData?.sourceOrigin === "EDIT_CHECKLIST" && !isFileModified) {
      let buildData = {
        ...(selectedChecklists?.length ? { signatureOf: selectedChecklists } : {}),
      };
      dispatch(transactionLaneDataHandle.verifyUploadDoc({ buildData, offerData: allData.doraDocItem }));
      if (setAllData) {
        setAllData({ ...allData, uploadPdfDoc: false, fileLink: "", sourceOrigin: "", doraDocItem: {} });
      }
      return;
    }
    if (!selectedFile) {
      message.error("No file selected for upload.");
      return;
    }
    setLoading(true);
    try {
      const fileName = selectedFile.name;
      const preSignedUrls = await getPreSignedUrls([fileName], "UPLOAD_DOC");
      const preSignedItem = preSignedUrls?.find((item) => item.fileName === fileName);

      if (!preSignedItem?.url) {
        message.error("Failed to generate upload URL.");
        return;
      }

      const uploadedFileLink = await uploadFileToS3(selectedFile, preSignedItem.url);
      if (!uploadedFileLink) {
        message.error("File upload failed.");
        return;
      }
      const contractId = Array.isArray(selectedData?.contractId) ? selectedData.contractId.pop() : selectedData?.contractId;
      const contractType = selectedData?.contractType;

      if (getCoordinateItem && customerDocsContTractTypes.includes(contractType)) {
        let buyerIds = [];
        let sellerIds = [];
        let buyerAgentIds = [];
        let sellerAgentIds = [];

        if (["ERTB", "CB_ERTB", "BDB", "FRASCONA_BDB"].includes(contractType)) {
          buyerIds = getCoordinateItem?.isProperty ? selectedData?.sellerIds : selectedData?.buyerIds;
          buyerAgentIds = getCoordinateItem?.isProperty ? getCoAgentsIds(selectedData?.sellerAgentIds) : getCoAgentsIds(selectedData?.buyerAgentIds);
        } else {
          sellerIds = getCoordinateItem?.isProperty ? selectedData?.sellerIds : selectedData?.buyerIds;
          sellerAgentIds = getCoordinateItem?.isProperty ? getCoAgentsIds(selectedData?.sellerAgentIds) : getCoAgentsIds(selectedData?.buyerAgentIds);
        }

        const buildData = {
          openFor: ["ERTB", "CB_ERTB", "BDB", "FRASCONA_BDB"].includes(contractType) ? "BUYER_AGENT" : "SELLER_AGENT",
          RTDInitiator: ["ERTB", "CB_ERTB", "BDB", "FRASCONA_BDB"].includes(contractType) ? "BUYER" : "SELLER",
          contractId,
          contractType,
          sellerIds,
          buyerIds,
          buyerAgentIds,
          sellerAgentIds,
          fileLink: uploadedFileLink,
        };
        dispatch(PropertyHandlers?.uploadPdfDocumentFunc({ data: buildData, successFunc }));
        return;
      }
      let buildData = {};
      if (["BHHS_CP_RA", "DC_CAL", "DC_RA"].includes(contractType)) {
        buildData = {
          openFor: "BUYER_AGENT",
          RTDInitiator: "BUYER",
          contractId,
          contractType,
          sellerIds: selectedData?.sellerIds || [],
          buyerIds: selectedData?.buyerIds || [],
          buyerAgentIds: [getUserDetailsData._id],
          sellerAgentIds: [],
          fileLink: uploadedFileLink,
        };
      } else {
        buildData = {
          openFor: selectedData?.RTDInitiator === "SELLER" ? "SELLER_AGENT" : "BUYER_AGENT",
          RTDInitiator: selectedData?.RTDInitiator === "SELLER" ? "SELLER" : "BUYER",
          contractId,
          contractType,
          openForPropertyDoc: selectedData?.RTDInitiator === "SELLER" ? "SELLER_AGENT" : "BUYER_AGENT",
          ...(selectedData?.offerId && contractType !== "NET_SHEET" && { offerId: selectedData.offerId }),
          ...(selectedData?.propertyId && { propertyId: selectedData.propertyId }),
          ...(selectedData?.clientDocId && { clientDocId: selectedData.clientDocId }),
          sellerIds: selectedData?.sellerIds || [],
          buyerIds: selectedData?.buyerIds || [],
          buyerAgentIds: source === "CONTACT_SECTION" ? selectedData?.buyerAgentIds : getCoAgentsIds(selectedData?.buyerAgentIds),
          sellerAgentIds: source === "CONTACT_SECTION" ? selectedData?.sellerAgentIds : getCoAgentsIds(selectedData?.sellerAgentIds),
          fileLink: uploadedFileLink,
          ...(source === "checklistTable" ? { isDeleted: true } : {}),
          ...(source === "checklistTable" && selectedChecklists?.length ? { signatureOf: selectedChecklists } : {}),
          ...(allData?.sourceOrigin === "EDIT_CHECKLIST" && selectedFile && allData?.doraDocItem?.fileUrl ? { fileName: selectedFile.name, fileType: "PDF" } : {}),
        };
      }
      if (allData?.sourceOrigin === "EDIT_CHECKLIST") {
        dispatch(transactionLaneDataHandle.verifyUploadDoc({ buildData, offerData: allData.doraDocItem }));
      } else {
        dispatch(PropertyHandlers?.uploadPdfDocumentFunc({ data: buildData, successFunc }));
      }

      if (setAllData) {
        setAllData({
          ...allData,
          uploadPdfDoc: false,
          fileLink: uploadedFileLink,
           sourceOrigin: "", doraDocItem: {}
        });
      }
    } catch (error) {
      console.error(error);
      message.error("Something went wrong while uploading.");
    } finally {
      setLoading(false); // Stop loader
    }
  };
    
    useEffect(() => {
      if (allData?.sourceOrigin === "EDIT_CHECKLIST") {
        setSelectedChecklists(allData.signatureOf || []);
        setSelectedFile({ ...selectedFile, name: allData.file });
        initialSignatureOfRef.current = allData.signatureOf || [];
        initialFileNameRef.current = allData.file;
      } else {
        setSelectedFile(null);
        setSelectedChecklists([]);
        initialSignatureOfRef.current = [];
        initialFileNameRef.current = null;
      }
    }, [allData?.sourceOrigin]);

    const isChecklistModified = JSON.stringify(initialSignatureOfRef.current?.sort()) !== JSON.stringify(selectedChecklists.sort());
    const isFileModified = selectedFile?.name && selectedFile?.name !== initialFileNameRef.current;
      
    return (
      <Modal open={open} onCancel={handleModalCancel} style={{ marginTop: "-50px" }} footer={false} width={700}>
        <div
          style={{
            minHeight: "350px",
          }}
        >
          {loading ? (
            <div style={{ paddingTop: "130px" }}>
              <Loading />
            </div>
          ) : (
            <>
              <div
                className='commonModalTitle'
                style={{
                  textAlign: "center",
                  fontSize: "1.2rem",
                  padding: "0px 0px 30px 0px",
                }}
              >
                {allData?.sourceOrigin === "EDIT_CHECKLIST" ? "Edit document" : "Upload a fully signed PDF document"}
              </div>
              <Dragger accept=".pdf,.PDF" progress={false} showUploadList={false} customRequest={handleCustome} beforeUpload={beforeUpload}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">Paste, Click or drag file to this area to upload</p>
                <p className="ant-upload-hint">Support for a single document/pdf upload.</p>
              </Dragger>
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                {selectedFile?.name && <h3>{selectedFile?.name}</h3>}
                {selectedFile?.size && <h6>Size: {bytesToSize(selectedFile?.size)}</h6>}
              </div>

              {source === "checklistTable" && (selectedFile?.name || selectedChecklists?.length > 0) && (
              <div style={{ margin: "10px 0 10px 0", display: "flex", justifyContent:"center" }}>
                <Checkbox.Group
                  options={checkboxOptions}
                  value={selectedChecklists}
                  onChange={handleCheckboxChange}
                />
              </div>
            )}

              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button type="primary" disabled={!selectedFile || (!isFileModified && !isChecklistModified)} onClick={handleSave}>
                  Done
                </Button>
              </div>
            </>
          )}
        </div>
      </Modal>
    );
}
